import { ICountryMap } from '../../app/common/fields/country/country';
import { SupportedLanguage } from '../../config/constants/supportedLanguage.enum';

export enum CountriesActionType {
    GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST',
    GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS',
    GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE',
}

export type CountriesAction =
    | { type: CountriesActionType.GET_COUNTRIES_REQUEST; payload: {} }
    | { type: CountriesActionType.GET_COUNTRIES_FAILURE; payload: {} }
    | {
          type: CountriesActionType.GET_COUNTRIES_SUCCESS;
          payload: { lang: SupportedLanguage; countries: ICountryMap };
      };
